import { render, staticRenderFns } from "./CartaoAprovacao.vue?vue&type=template&id=7e387775&scoped=true"
import script from "./CartaoAprovacao.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoAprovacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoAprovacao.vue?vue&type=style&index=0&id=7e387775&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e387775",
  null
  
)

export default component.exports